import  React from 'react'

interface Props {
}

export const Loading : React.FC<Props> = () => (
  <>
    <div className="container-fluid mt-2 text-center"><h5>Please wait. Loading...</h5></div>
  </>
)
